/** `period` query param shared by endpoints that support activity time-range filtering. */
export type TimeRangePeriod = "day" | "week" | "month" | "all_time";

export const DEFAULT_TIME_RANGE_PERIOD: TimeRangePeriod = "all_time";

export const TIME_RANGE_PERIOD_OPTIONS = [
  { value: "day", translationKey: "common.timeRange.day" },
  { value: "week", translationKey: "common.timeRange.week" },
  { value: "month", translationKey: "common.timeRange.month" },
  { value: DEFAULT_TIME_RANGE_PERIOD, translationKey: "common.timeRange.allTime" },
] as const satisfies readonly {
  value: TimeRangePeriod;
  translationKey: string;
}[];
